import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

const IDS = {
  DOCUMENTS_PAYOFF_LABEL: 'sitemap.documents.payoff.label',
  MORTGAGE_LABEL: 'sitemap.mortgage.label',
  MORTGAGE_MORTGAGEDETAILS_LABEL: 'sitemap.mortgage.mortgageDetails.label',
};

const enMessages = {
  [IDS.DOCUMENTS_PAYOFF_LABEL]: 'Payoff',
  [IDS.MORTGAGE_LABEL]: 'Mortgage',
  [IDS.MORTGAGE_MORTGAGEDETAILS_LABEL]: 'Mortgage Details',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.DOCUMENTS_PAYOFF_LABEL]: 'Discounted Murabaha Debt/Payoff Statements',
  [IDS.MORTGAGE_LABEL]: 'Murabaha',
  [IDS.MORTGAGE_MORTGAGEDETAILS_LABEL]: 'Murabaha Financing Transaction Details',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
